import { Route } from 'react-router-dom';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';
import InvestInTheFuture from '../pages/partner/InvestInTheFuture';

export const PartnerRoutes = [
  <Route 
    key="invest" 
    path="/invest-in-the-future" 
    element={
      <ProtectedRoute requiredRole="partner">
        <InvestInTheFuture />
      </ProtectedRoute>
    } 
  />
]; 